import KEY from "../clientVariables.json";
export default function generateEdismaxSolrQuery(
  keywords,
  start = 0,
  rows = 10,
  sort = "posted_date desc",
  keywordsForORcondition
) {
  let mainQuery = "*:*"; // Default query
  const fqQueries = Object.keys(keywords)
    .map((field) => {
      const value = keywords[field];
      const encodedValue = encodeURIComponent(value);

if (field === "location") {
  if (value.toLowerCase() === '"remote"' || value.toLowerCase() === "remote") {
    return "remote:1"; 
  }
  return `${field}:${encodedValue}`; 
}

      // Default case for fields other than "jobtitle"
      return `${field}:${encodedValue}`;
    })
    .filter(Boolean); // Remove any null values

  const fqQuery = fqQueries.length ? fqQueries.join("&q=") : null;

  const buildQueryString = (params) => {
    const queryString = Object.entries(params)
      .filter(([, value]) => value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return queryString;
  };

  // const q_ = `${mainQuery}${fqQuery}`

  const queryParams = buildQueryString({
    fq: fqQuery,
    "q.op": "AND",
    start: start,
    rows: rows,
    sort: sort,
  });

  return `${KEY?.solr}/${KEY?.candidate_jobs_solr}/select?defType=edismax&${queryParams}`;
}
